import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TreeViewInputModel, TreeViewModel } from '../../models/tree-view-model';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-tree-view',
  templateUrl: './tree-view.component.html',
  styleUrls: ['./tree-view.component.css']
})

export class TreeViewComponent {

  constructor(
    private logger: LoggerService
  ) {

  }

  @Input() Value!:TreeViewInputModel;
  
  @Output() changeVariableMonth = new EventEmitter<string>();

  public openParent(item: TreeViewModel) {
    try {
      if (!item.childrens) {
        return;
      }

      item.isOpen = !item.isOpen;
    } catch (error) {
      this.logger.addException(error, false);
    }
  }

  public changeCheckBox(item: TreeViewModel, parent?: TreeViewModel, grangParent?: TreeViewModel) {
    try {
      if (!parent) {

        if (!item.childrens) {
          return;
        }

        for (let index = 0; index < item.childrens.length; index++) {
          const element = item.childrens[index];
          element.isEnable = item.isEnable;
        }

        return;
      }

      var foundedEqual = parent.childrens
        ?.filter(current => current.isEnable == item.isEnable);

      if (foundedEqual?.length == parent.childrens?.length) {
        parent.isEnable = item.isEnable;
        parent.isIndeterminate = false;
      } else {
        parent.isEnable = false;
        parent.isIndeterminate = true;
      }

      if (!grangParent) {
        return;
      }

      var foundedGrandParentEqual = grangParent.childrens
        ?.filter(current => current.isEnable == parent.isEnable);

      if (foundedGrandParentEqual?.length == grangParent.childrens?.length) {
        grangParent.isEnable = parent.isEnable;
        grangParent.isIndeterminate = false;
      } else {
        grangParent.isEnable = false;
        parent.isIndeterminate = true;
      }

    } catch (error) {
      this.logger.addException(error, false);
    }
  }

  public deleteItem(item: TreeViewModel, parent?: TreeViewModel) {
    try {
      if (!parent) {
        this.Value.inputData.forEach((element, index) => {
          if (element.id == item.id) {
            this.Value.inputData.splice(index, 1);
          }
        });
        return;
      }

      if (!parent.childrens) {
        return;
      }

      parent.childrens.forEach((element, index) => {
        if (element.id == item.id) {
          parent.childrens!.splice(index, 1);
        }
      });

      if (parent.childrens.length == 0) {
        parent.childrens = undefined;
        parent.isEnable = false;
        parent.isIndeterminate = false;
      }


    } catch (error) {
      this.logger.addException(error, false);
    }
  }

  public addItem(parent?: TreeViewModel) {
    try {

      if (!parent) {
        this.Value.inputData.push(new TreeViewModel("example"));
        return;
      }

      if (!parent.childrens) {
        parent.childrens = [];
      }

      parent.childrens.push(new TreeViewModel("example"));

    } catch (error) {
      this.logger.addException(error, false);
    }
  }
}

